export default __webpack_public_path__ + "static/media/ionic-logo-youtube.9d067a4a.svg";